var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgComment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_226_290",
    "data-name": "Component 226 \\u2013 290",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.483,
    height: 6.454,
    viewBox: "0 0 7.483 6.454",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_956",
    "data-name": "Path 956",
    transform: "translate(4129.953 5748.507)",
    fill: "#ff7979"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4122.7216796875 -5742.6005859375 L -4129.2802734375 -5748.2568359375 L -4122.74267578125 -5748.2568359375 L -4122.7216796875 -5742.6005859375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4128.60791015625 -5748.0068359375 L -4122.9736328125 -5743.14794921875 L -4122.99169921875 -5748.0068359375 L -4128.60791015625 -5748.0068359375 M -4129.953125 -5748.5068359375 L -4122.49365234375 -5748.5068359375 L -4122.4697265625 -5742.05322265625 L -4129.953125 -5748.5068359375 Z",
    stroke: "none",
    fill: "#ff7979"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "b3dcea5871b96483a27c079e1639a576.svg";